import { render } from "./LeaderboardsAuthorsSummary.vue?vue&type=template&id=f743eb7a"
import script from "./LeaderboardsAuthorsSummary.vue?vue&type=script&lang=js"
export * from "./LeaderboardsAuthorsSummary.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__